import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from '@core/components/base-component';
import { SideMenuItem } from '../models/side-menu-item.model';

@Component({
  selector: 'pop-side-menu-section',
  templateUrl: './side-menu-section.component.html',
  styleUrls: ['./side-menu-section.component.less']
})
export class SideMenuSectionComponent extends BaseComponent implements OnInit {
  @Input() public menuSection: SideMenuItem;

  public isExpanded = true;

  public isVisible = true;

  public constructor() {
    super();
  }

  public ngOnInit(): void {
    if (this.menuSection.$isHidden) {
      this.subscribe(
        this.menuSection.$isHidden.subscribe(isHidden => {
          this.isVisible = !isHidden;
        })
      );
    }
    this.isExpanded = this.menuSection.isExpanded;
  }

  public toggle() {
    this.isExpanded = !this.isExpanded;
  }
}
